"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_181)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_181`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V8.00006H-6V0.000244141ZM-6 15.9999H30V23.9998H-6V15.9999Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.6713 11.9999C14.6713 13.4752 13.4753 14.3373 12 14.3373C10.5247 14.3373 9.32874 13.4752 9.32874 11.9999C9.32874 10.5246 10.5248 9.32861 12.0001 9.32861C13.4753 9.32861 14.6713 10.5246 14.6713 11.9999Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.6712 12C14.6712 13.4753 13.4752 14.6713 11.9999 14.6713C10.5246 14.6713 9.32861 13.4753 9.32861 12",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.3307 11.3326H10.9985V12.6685H10.3307V11.3326ZM13.0017 11.3326H13.6696V12.6685H13.0017V11.3326ZM11.6658 10.3308H12.3336V12.6682H11.6658V10.3308Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_181`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PFFlag };
